(() => {
  document.addEventListener('click', event => {
    const link = event.target.closest('.woc-header a[href], .woc-footer a[href]');
    if (!link || new URL(link.href).pathname !== document.body.dataset.wocCartUrl) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(link.href);
  }, true);
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('form[data-type="add-to-cart-form"]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const button = event.submitter || form.querySelector('button[type="submit"]');
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    let message = form.querySelector('[data-woc-cart-error]');
    if (message) message.remove();
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || document.body.dataset.wocCartError);
      window.location.assign(document.body.dataset.wocCartUrl || '/cart');
    } catch (error) {
      message = document.createElement('p');
      message.dataset.wocCartError = 'true';
      message.setAttribute('role', 'alert');
      message.textContent = error.message || document.body.dataset.wocCartError;
      form.appendChild(message);
      if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
    }
  }, true);
  const init = (root = document) => {
    root.querySelectorAll('[data-woc-menu]').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      menu.querySelectorAll('[data-woc-close]').forEach(button => button.addEventListener('click', () => { menu.open = false; menu.querySelector('summary').focus(); }));
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); }
        if (event.key === 'Tab' && menu.open) {
          const elements = [...menu.querySelectorAll('summary,button,a[href],input')].filter(x => !x.disabled && x.getClientRects().length);
          const first = elements[0], last = elements[elements.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      });
      menu.addEventListener('toggle', () => { document.documentElement.style.overflow = menu.open ? 'hidden' : ''; });
    });
    root.querySelectorAll('[data-woc-faq]').forEach(faq => {
      if (faq.dataset.ready) return;
      faq.dataset.ready = 'true';
      let category = '';
      const search = faq.querySelector('[data-faq-search]');
      const items = [...faq.querySelectorAll('[data-faq-item]')];
      const filter = () => {
        const q = search.value.trim().toLocaleLowerCase();
        let count = 0;
        items.forEach(item => { const show = (!category || item.dataset.category === category) && (!q || item.textContent.toLocaleLowerCase().includes(q)); item.hidden = !show; if (show) count++; });
        faq.querySelector('[data-faq-empty]').hidden = count !== 0;
      };
      search.addEventListener('input', filter);
      faq.querySelectorAll('[data-faq-category]').forEach(button => button.addEventListener('click', () => {
        category = button.dataset.faqCategory;
        faq.querySelectorAll('[data-faq-category]').forEach(x => x.setAttribute('aria-pressed', String(x === button)));
        filter();
      }));
    });
    root.querySelectorAll('[data-woc-petition]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const tool = form.closest('.woc-tool'), result = tool.querySelector('[data-petition-result]');
      let generated = '';
      form.addEventListener('submit', event => {
        event.preventDefault();
        const fields = new FormData(form), name = fields.get('petitioner').trim(), intention = fields.get('intention'), words = fields.get('words').trim();
        const petition = `${name}\n\nMy intention: ${intention}\n\n${words}\n\nI speak these words with clarity, purpose, and steady faith. May the road open for this working in the way that serves my stated intention.`;
        const chant = `With a clear mind and a steady voice,\nI name my intention: ${intention}.\n${words}\nMy words are spoken. My purpose is clear.`;
        tool.querySelector('[data-petition-text]').textContent = petition;
        tool.querySelector('[data-chant-text]').textContent = chant;
        generated = `WORLD OF CONJURE\nWorldOfConjure.com\n\nMY PETITION\n${petition}\n\nMY SPOKEN WORDS\n${chant}\n`;
        result.hidden = false;
        result.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      });
      tool.querySelector('[data-petition-download]').addEventListener('click', () => {
        const blob = new Blob([generated], { type: 'text/plain;charset=utf-8' });
        const href = URL.createObjectURL(blob), link = document.createElement('a');
        link.href = href; link.download = 'World_of_Conjure_Petition.txt'; link.click();
        setTimeout(() => URL.revokeObjectURL(href), 1000);
      });
      tool.querySelector('[data-petition-print]').addEventListener('click', () => { document.body.classList.add('woc-print-petition'); window.print(); });
      window.addEventListener('afterprint', () => document.body.classList.remove('woc-print-petition'));
    });
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) {
      document.querySelectorAll('a[href]').forEach(a => {
        const target = new URL(a.href, location.href);
        if (target.origin === location.origin && !target.pathname.startsWith('/account') && !target.pathname.startsWith('/checkout') && !target.searchParams.has('preview_theme_id')) {
          target.searchParams.set('preview_theme_id', preview); a.href = target.href;
        }
      });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
